import React, { useState } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import LeadForm from '~/components/index/LeadForm/LeadForm';
import DialogPrompt from '~/components/common/DialogPrompt/DialogPrompt';

import css from './YuesaoFeed.less';
import { resizeImage } from '../../../utils/util';

const TagAppraise = () => {
  return (
    <svg
      width="48"
      height="19"
      viewBox="0 0 48 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <path
        d="M0 9.5C0 4.25329 4.2533 0 9.5 0H44.8C45.9201 0 46.4802 0 46.908 0.217987C47.2843 0.409734 47.5903 0.715695 47.782 1.09202C48 1.51984 48 2.0799 48 3.2V3.8C48 9.1205 48 11.7807 46.9646 13.8129C46.0538 15.6004 44.6004 17.0538 42.8129 17.9646C40.7807 19 38.1205 19 32.8 19H9.5C4.2533 19 0 14.7467 0 9.5Z"
        fill="#FF385C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1219 5.59753L12.1177 9.60183L10.6334 8.11761L9.39599 9.35505L11.4989 11.458C11.8406 11.7997 12.3947 11.7997 12.7364 11.458L16.9824 7.21198C17 7.38868 17 7.61426 17 8V9V10C17 11.4001 17 12.1002 16.7275 12.635C16.4878 13.1054 16.1054 13.4878 15.635 13.7275C15.1002 14 14.4001 14 13 14H12C10.5999 14 9.8998 14 9.36502 13.7275C8.89462 13.4878 8.51217 13.1054 8.27248 12.635C8 12.1002 8 11.4001 8 10V9C8 7.59987 8 6.8998 8.27248 6.36502C8.51217 5.89462 8.89462 5.51217 9.36502 5.27248C9.8998 5 10.5999 5 12 5H14C14.4645 5 14.6968 5 14.8911 5.03078C15.3573 5.10462 15.7797 5.30565 16.1219 5.59753Z"
        fill="white"
      />
      <path
        d="M25.19 11.31C25.9167 12.0167 26.3967 12.5067 26.63 12.78L25.65 14.03C25.37 13.6367 25.0033 13.1633 24.55 12.61C24.4167 12.8767 24.2433 13.13 24.03 13.37C23.8167 13.6167 23.54 13.89 23.2 14.19L22.13 13.13C22.5433 12.7833 22.8733 12.4767 23.12 12.21C23.3733 11.9367 23.5667 11.66 23.7 11.38H22.74V6.15L22.04 7.19C21.8733 7.04333 21.6333 6.85333 21.32 6.62C21.0067 6.38 20.75 6.19667 20.55 6.07L21.43 4.89C21.81 5.09667 22.2467 5.39333 22.74 5.78V5.18H26.3V11.31H25.26V6.68H23.72V11.33C23.8333 11.0833 23.9133 10.81 23.96 10.51C24.0067 10.2033 24.03 9.83667 24.03 9.41V7L24.99 7.03V9.84C24.99 10.3667 24.9733 10.7767 24.94 11.07L25.19 11.31ZM27.97 4.93L29.24 4.97V12.82C29.24 13.1067 29.2 13.3267 29.12 13.48C29.04 13.6333 28.9067 13.75 28.72 13.83C28.5333 13.91 28.2567 13.98 27.89 14.04L27.47 14.11L26.97 12.46L27.41 12.41C27.61 12.39 27.7533 12.3433 27.84 12.27C27.9267 12.1967 27.97 12.08 27.97 11.92V4.93ZM26.63 5.63L27.67 5.67V11.77H26.63V5.63ZM21.83 9.7C21.6567 9.54 21.4233 9.34 21.13 9.1C20.8367 8.86 20.57 8.65 20.33 8.47L21.21 7.27C21.93 7.77 22.4167 8.14333 22.67 8.39L21.83 9.7ZM22.49 10.42C22.39 10.9667 22.2667 11.6133 22.12 12.36C21.98 13.1 21.8633 13.6833 21.77 14.11L20.39 13.77C20.53 13.3367 20.6833 12.7167 20.85 11.91C21.0167 11.1033 21.13 10.47 21.19 10.01L22.49 10.42ZM31.8523 7.59C31.7123 7.36333 31.499 7.06667 31.2123 6.7C30.9323 6.32667 30.6957 6.04 30.5023 5.84L31.7523 4.87C31.9657 5.08333 32.1957 5.33667 32.4423 5.63C32.6957 5.92333 32.899 6.18 33.0523 6.4L31.8523 7.59ZM39.3823 9.95V11.51H37.1023V14.12H35.5223V11.51H33.4323L33.6023 12.62C33.029 13.0333 32.6157 13.34 32.3623 13.54C32.189 13.6733 31.9623 13.8667 31.6823 14.12L30.7423 12.94C30.8957 12.78 30.999 12.6167 31.0523 12.45C31.1057 12.2767 31.1357 12.0367 31.1423 11.73V9.41H30.3823V7.81H32.6523V11.53C32.8123 11.3767 32.9723 11.2333 33.1323 11.1L33.2823 10.97V9.95H35.5223V6.7H33.5423V5.18H39.0923V6.7H37.1023V9.95H39.3823ZM34.7023 7.14C34.8223 7.38667 34.9557 7.71 35.1023 8.11C35.249 8.51 35.3557 8.85333 35.4223 9.14L34.1523 9.51C33.8857 8.59 33.6623 7.92333 33.4823 7.51L34.7023 7.14ZM37.1623 9.13C37.289 8.81667 37.4123 8.47667 37.5323 8.11C37.659 7.73667 37.7557 7.41667 37.8223 7.15L39.0523 7.5C38.9857 7.76 38.8823 8.09667 38.7423 8.51C38.609 8.91667 38.489 9.24667 38.3823 9.5L37.1623 9.13Z"
        fill="white"
      />
    </svg>
  );
};

const TagPekingMedical = () => {
  return (
    <svg
      width="68"
      height="19"
      viewBox="0 0 68 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <path
        d="M0 9.5C0 4.25329 4.25329 0 9.5 0H64.8C65.9201 0 66.4802 0 66.908 0.217987C67.2843 0.409734 67.5903 0.715695 67.782 1.09202C68 1.51984 68 2.0799 68 3.2V3.8C68 9.1205 68 11.7807 66.9646 13.8129C66.0538 15.6004 64.6004 17.0538 62.8129 17.9646C60.7807 19 58.1205 19 52.8 19H9.5C4.2533 19 0 14.7467 0 9.5Z"
        fill="#00C2FF"
      />
      <path
        d="M22.53 6.97V4.88L24.23 4.92V14.08H22.53V12.77C21.77 13.0633 21.1633 13.2867 20.71 13.44L20.25 11.64C20.51 11.5533 20.86 11.43 21.3 11.27C21.7467 11.1033 22.1567 10.9433 22.53 10.79V8.71H20.66V6.97H22.53ZM29.64 11.47C29.6 11.9033 29.5433 12.2867 29.47 12.62C29.39 12.9667 29.2933 13.23 29.18 13.41C29.0667 13.5967 28.9033 13.73 28.69 13.81C28.4833 13.8967 28.1933 13.9467 27.82 13.96C27.7133 13.9667 27.55 13.97 27.33 13.97C27.11 13.97 26.9433 13.9667 26.83 13.96C26.41 13.9467 26.0833 13.89 25.85 13.79C25.6167 13.6967 25.4467 13.5333 25.34 13.3C25.24 13.0733 25.19 12.7467 25.19 12.32V4.88L26.87 4.92V7.54C27.5033 7.12 28.0367 6.73 28.47 6.37L29.45 7.89C28.7033 8.41667 27.8433 8.97333 26.87 9.56V11.9C26.87 12.0533 26.9 12.1633 26.96 12.23C27.0267 12.29 27.1333 12.3267 27.28 12.34C27.38 12.3533 27.48 12.3533 27.58 12.34C27.7267 12.32 27.8233 12.2833 27.87 12.23C27.9233 12.1767 27.97 12.0633 28.01 11.89C28.05 11.7167 28.0767 11.5733 28.09 11.46C28.11 11.3467 28.1267 11.1733 28.14 10.94L29.64 11.47ZM35.6223 8.51C35.909 9.45667 36.3623 10.2533 36.9823 10.9C37.609 11.5467 38.4223 12.0867 39.4223 12.52L38.3423 14.05C37.369 13.4567 36.6157 12.9033 36.0823 12.39C35.5557 11.87 35.1423 11.2633 34.8423 10.57C34.569 11.19 34.149 11.7833 33.5823 12.35C33.0223 12.91 32.2657 13.4833 31.3123 14.07L30.2223 12.57C31.009 12.1567 31.6557 11.75 32.1623 11.35C32.669 10.9433 33.0657 10.5133 33.3523 10.06C33.639 9.6 33.8323 9.08333 33.9323 8.51H30.6423V6.86H34.0223V4.85L35.6523 4.89V6.86H39.0123V8.51H35.6223ZM48.4647 12.36H49.2447V13.97H40.5547V5.03H49.0947V6.62H42.1347V12.36H43.1747L42.3647 11.09C43.038 10.9833 43.5414 10.8733 43.8747 10.76C44.2147 10.6467 44.458 10.49 44.6047 10.29H42.5247V8.95H44.8747V8.39H44.1047C43.998 8.53667 43.8647 8.70333 43.7047 8.89L42.3647 8.19C42.7647 7.79667 43.1114 7.29667 43.4047 6.69L45.0247 6.87L44.9147 7.1H48.4847V8.39H46.4647V8.95H48.9347V10.29H46.3647L46.3547 10.35C46.7214 10.4633 47.1514 10.6067 47.6447 10.78C48.138 10.9467 48.5614 11.0967 48.9147 11.23L48.4647 12.36ZM43.8847 12.36H47.5747C46.908 12.0467 46.2714 11.7667 45.6647 11.52C45.298 11.84 44.7047 12.12 43.8847 12.36ZM58.987 5.82V10.25H55.277C55.237 11.1033 55.157 11.81 55.037 12.37C54.917 12.9233 54.717 13.5367 54.437 14.21L52.927 13.4C53.1737 12.9267 53.357 12.4967 53.477 12.11C53.6037 11.7167 53.6937 11.2633 53.747 10.75C53.8004 10.2367 53.827 9.56667 53.827 8.74V5.82H55.547L55.317 4.84H57.047L57.257 5.82H58.987ZM53.387 10.61L52.687 10.72V12.86C52.687 13.2067 52.647 13.4567 52.567 13.61C52.4937 13.7633 52.3637 13.87 52.177 13.93C51.9904 13.99 51.6737 14.0467 51.227 14.1L50.647 14.17L50.187 12.58L50.627 12.51C50.8004 12.4833 50.9304 12.4367 51.017 12.37C51.1037 12.3033 51.147 12.1967 51.147 12.05V10.93L50.597 11.01C50.4904 11.03 50.3904 11.0467 50.297 11.06C50.2104 11.0733 50.127 11.0867 50.047 11.1L49.967 9.45L50.607 9.36C50.847 9.33333 51.027 9.31 51.147 9.29V7.88H50.297V6.32H51.147V4.85L52.687 4.89V6.32H53.407V7.88H52.687V9.08L52.937 9.04C53.117 9.02 53.2637 8.99667 53.377 8.97L53.387 9.82V10.61ZM55.307 8.73H57.497V7.36H55.307V8.3V8.73Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.48669 5.73768C10.3504 5.73874 11.6037 5.61607 12.5 5C13.3963 5.61607 14.6496 5.73874 15.5133 5.73768C16.0366 5.73704 16.5 6.15962 16.5 6.69913V10.2625C16.5 12.5823 12.5 14 12.5 14C12.5 14 8.5 12.5823 8.5 10.2625V6.69913C8.5 6.15962 8.96341 5.73704 9.48669 5.73768ZM11.8413 10.001H9.99854V8.68848H11.8413V6.8457H13.1538V8.68848H14.9985V10.001H13.1538V11.8457H11.8413V10.001Z"
        fill="white"
      />
    </svg>
  );
};

const YuesaoFeed = ({ index, dispatch }) => {
  const { recommendations: feedItems = [], loading } = index;
  const hasResults = feedItems.length > 0;
  const isCompactGrid = hasResults && feedItems.length < 4;
  const [promptMessage, setPromptMessage] = useState(null);

  const handleLeadFormSubmit = React.useCallback(
    ({ year, month, day, phone }) => {
      const formattedMonth = String(month).padStart(2, '0');
      const formattedDay = String(day).padStart(2, '0');
      const expectedBirthDate = `${year}-${formattedMonth}-${formattedDay}`;
      dispatch({
        type: 'index/submitLeadForm',
        payload: {
          due_date: expectedBirthDate,
          phone,
        },
      });
      setPromptMessage('信息已提交给您的专属顾问，稍后将会与您取得联络');
    },
    [dispatch],
  );

  const handlePromptConfirm = () => {
    setPromptMessage(null);
  };

  if (loading) {
    return (
      <section className={css.section}>
        <div className={css.loadingState}>正在为您寻找合适的月嫂...</div>
      </section>
    );
  }

  return (
    <section className={classNames(css.section, { [css.sectionEmpty]: !hasResults })}>
      {hasResults ? (
        <>
          <div className={classNames(css.grid, { [css.gridCompact]: isCompactGrid })}>
            {feedItems.map(item => {
              const renderPrice = () => {
                return (
                  <span className={css.priceBadge}>
                    <span className={css.priceCurrency}>¥</span>
                    <span aria-hidden className={css.priceMask} />
                  </span>
                );
              };
              const primaryReviewer =
                item.test_sharings[0]?.user.nickname || item.test_sharings[0]?.user.name || '真实用户';
              const condensedReviewer =
                primaryReviewer && primaryReviewer.length > 2 ? `${primaryReviewer.slice(0, 2)}...` : primaryReviewer;
              const reviewSummary = item.test_sharings.length
                ? `${condensedReviewer}等${item.test_sharings.length}人亲测评价`
                : '真实用户亲测评价';

              const renderTag = () => {
                if (item.has_peking_medical_training) {
                  return (
                    <span className={css.tagPekingMedical}>
                      <TagPekingMedical />
                    </span>
                  );
                }
                if (item.has_appraise) {
                  return (
                    <span className={css.tagAppraise}>
                      <TagAppraise />
                    </span>
                  );
                }
                return null;
              };

              return (
                <a className={css.card} key={item.id}>
                  <div className={css.cardImage}>
                    {item.headimgurl ? (
                      <img src={resizeImage(item.headimgurl)} alt={item.name} />
                    ) : (
                      <div className={css.imageFallback}>{item.title ? item.title.charAt(0) : '月'}</div>
                    )}
                    {renderTag()}
                  </div>
                  <div className={css.cardBody}>
                    <div className={css.cardTitleRow}>
                      <h3 title={item.name}>{item.name}</h3>
                      {renderPrice()}
                    </div>
                    <p className={css.subtitle}>
                      {item.hometown}·{item.age}·{item.education}
                    </p>
                    <div className={css.divider} />
                    <div className={css.reviewRow}>
                      <div className={css.avatars}>
                        {item.test_sharings.slice(0, 4).map(reviewer => {
                          const key = reviewer?.id || reviewer;
                          const avatar = typeof reviewer === 'string' ? reviewer : reviewer?.user.headimgurl;
                          if (!avatar) {
                            return null;
                          }
                          return (
                            <span key={key}>
                              <img src={avatar} alt="" />
                            </span>
                          );
                        })}
                      </div>
                      <span className={css.reviewText} title={reviewSummary}>
                        {reviewSummary}
                      </span>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
          {isCompactGrid ? (
            <div className={css.inlineLeadForm}>
              <LeadForm onSubmit={handleLeadFormSubmit} variant="inline" />
            </div>
          ) : (
            <LeadForm onSubmit={handleLeadFormSubmit} variant="overlay" />
          )}
        </>
      ) : (
        <div className={css.emptyState} role="status">
          <div className={css.emptyCopy}>
            <p className={css.emptyTitle}>暂时没有找到符合您预产期的月嫂</p>
            <p className={css.emptyDescription}>您可以留下联系方式</p>
            <p className={css.emptyDescription}>专属顾问将尽快为您匹配档期合适的月嫂阿姨</p>
          </div>
          <LeadForm onSubmit={handleLeadFormSubmit} variant="inline" />
        </div>
      )}
      {promptMessage ? <DialogPrompt message={promptMessage} onConfirm={handlePromptConfirm} /> : null}
    </section>
  );
};

export default connect(({ index }) => ({ index }))(YuesaoFeed);
